<template>
  <div class="mt-2 p-4 rounded-md shadow-sm border border-gray-300 text-sm">
    <p class="font-bold text-sm">Select Member Accounts</p>
    <ul class="mt-2 space-y-2" data-test="account-picker">
      <li v-for="member in members" :key="member.uuid">
        <header
          class="grid grid-cols-3 bg-gray-100 p-2 text-xs text-gray-500 uppercase"
        >
          <p class="col-span-2 font-semibold">{{ member.name }}</p>
          <p>Identifier</p>
        </header>
        <ul class="mt-2 space-y-2">
          <li
            v-for="account in memberAccounts(member.uuid)"
            :key="account.identifier"
            class="grid grid-cols-3 leading-7"
          >
            <!-- eslint-disable max-len -->
            <m-checkbox-item
              v-model="accounts"
              :label="account.label"
              :value="`${member.uuid}#${account.type}#${account.identifier}`"
              :disabled="selectedAccountType !== undefined && account.type !== selectedAccountType"
              :checked="
                accounts.includes(
                  `${member.uuid}#${account.type}#${account.identifier}`,
                )
              "
              class="col-span-2"
            />
            <!-- eslint-enable max-len -->
            <p>{{ account.identifier }}</p>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash';
import { pensionInstructionMixin } from '@/app/mixins/toolkit/pension-instructions/instruction';


const accountTypeMap = {
  'All Accumulation Accounts': 'accumulation',
  'All Pension Accounts': 'pension',
};

export default {
  name: 'account-picker',
  mixins: [pensionInstructionMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      accounts: [],
    };
  },
  computed: {
    memberAccounts() {
      return memberUUID => this.getItem.members[memberUUID].accounts;
    },
    selectedAccountType() {
      return this.accounts.length > 0 ? this.accounts[0].split('#')[1] : accountTypeMap[this.selection];
    },
  },
  watch: {
    accounts(val) {
      const members = {};
      val.forEach((account) => {
        const [memberUUID,, identifier] = account.split('#');
        const member = this.getItem.members[memberUUID];
        if (members[memberUUID]) {
          members[memberUUID].accounts[identifier] = member.accounts[identifier];
        } else {
          members[memberUUID] = {
            uuid: member.uuid,
            name: member.name,
            accounts: {
              [identifier]: member.accounts[identifier],
            },
          };
        }
      });

      this.$emit('input', {
        ..._.keyBy(members, 'uuid'),
      });
    },
  },
  mounted() {
    const members = _.values(this.value);
    this.accounts = members.flatMap(member => _.values(member.accounts).flatMap(account => `${member.uuid}#${account.type}#${account.identifier}`));
  },
};
</script>
